<template>
  <div class="datasets-header">
    <h3 class="header-title">
      {{ $t("Datasets") }}
    </h3>
    <div class="row justify-between">
      <div>
        <span class="total-result">{{totalResults}}</span> {{$t("Datasets-total")}}
        <a :href="reuseUrl" title="" class="search-reuses">
          {{ $t("Search reuses") }}
          <svg width="14" height="10" viewBox="0 0 14 10" fill="none" 
            xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.3 0.7L12.1 4.5H0V5.5H12.1L8.3 9.3L9 10L14 5L9 0L8.3 0.7Z" fill="#4B90F5"/>
          </svg>
        </a>
      </div>
      <div>
        <a href="https://data.gov.rs/sr/datasets.csv?" title="" class="search-reuses">
          {{ $t("Download datasets")}}
          <svg width="14" height="10" viewBox="0 0 14 10" fill="none" 
            xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.3 0.7L12.1 4.5H0V5.5H12.1L8.3 9.3L9 10L14 5L9 0L8.3 0.7Z" fill="#4B90F5"/>
          </svg>
        </a>
      </div>
    </div>
  </div>
  <div class="row-inline justify-between align-items-center search-bar">
    <search-input
      class="fr-my-1w fr-my-md-2w fr-text--lead fr-mb-0"
      :onChange="handleSearchChange"
      :value="queryString"
      :placeholder="$t('Search for data...')"
      ref="input"
    />
    <div
      class="filter-icon fr-hidden-md w-auto fr-mx-3v"
      :class="{ isFiltered, active: extendedForm }"
      v-html="filterIcon"
      @click="extendedForm = !extendedForm"
    ></div>
  </div>
  <section class="search-filters fr-p-2w fr-p-md-0" :class="{active: extendedForm}">
    <!-- <h2 class="fr-mt-md-2w fr-mb-2w fr-mb-md-1w fr-text--sm">
      {{ $t("Search filters") }}
    </h2> -->
    <div class="filters-wrapper fr-p-md-3v">
      <div class="fr-grid-row fr-grid-row--gutters justify-between align-items-center">
        <div class="fr-col-12 fr-col-md-6 fr-col-lg-3">
          <Suggestor
            :placeholder="$t('Search by sort...')"
            :searchPlaceholder="$t('Search by sort...')"
            listUrl="/organizations/"
            :options="sortValues"
            :values="facets.sort"
            :onChange="handleSuggestorChange('sort')"
          />
        </div>
        <div class="fr-col-12 fr-col-md-6 fr-col-lg-3">
          <Suggestor
            :placeholder="$t('Organizations')"
            :searchPlaceholder="$t('Search an organization...')"
            listUrl="/organizations/"
            suggestUrl="/organizations/suggest/"
            entityUrl="/organizations/"
            :values="facets.organization"
            :onChange="handleSuggestorChange('organization')"
          />
        </div>
        <div class="fr-col-12 fr-col-md-6 fr-col-lg-3">
          <Suggestor
            :placeholder="$t('Tags')"
            :searchPlaceholder="$t('Search a tag...')"
            listUrl="/tags/"
            :values="facets.tag"
            :onChange="handleSuggestorChange('tag')"
          />
        </div>
        <!-- <div class="fr-col-12 fr-col-md-5 fr-col-lg-3">
          <Suggestor
            :placeholder="$t('Licenses')"
            :searchPlaceholder="$t('Search a license...')"
            listUrl="/datasets/licenses/"
            :values="facets.license"
            :onChange="handleSuggestorChange('license')"
          />
        </div> -->
        <div class="fr-col-12 fr-col-md-5 fr-col-lg-2">
          <Suggestor
            :placeholder="$t('Formats')"
            :searchPlaceholder="$t('Search a format...')"
            listUrl="/datasets/extensions/"
            :values="facets.format"
            :onChange="handleSuggestorChange('format')"
          />
        </div>
        <div
          class="fr-col-2 fr-col-lg-1 fr-displayed-md text-align-center text-align-right-lg"
        >
          <button
            class="fr-btn fr-btn--secondary fr-btn--secondary-grey-200 text-grey-380 fr-px-2w"
            @click="extendedForm = !extendedForm"
            data-cy="extend-form"
          >
            <span v-if="!extendedForm">…</span>
            <span v-else>X</span>
          </button>
        </div>
      </div>
      <div
        v-if="extendedForm"
        data-cy="extended-form"
        class="fr-grid-row fr-grid-row--gutters fr-mt-3v align-items-center"
      >
        <!-- <div class="fr-col-12 fr-col-md-6 fr-col-lg-5 row-inline">
          <Rangepicker
            :value="facets.temporal_coverage"
            :onChange="handleSuggestorChange('temporal_coverage')"
          />
        </div> -->
        <div class="fr-col-12 fr-col-md-3">
          <Suggestor
            :placeholder="$t('Geographic area')"
            :searchPlaceholder="$t('Search a geographic area...')"
            suggestUrl="/spatial/zones/suggest/"
            entityUrl="/spatial/zone/"
            :values="facets.geozone"
            :onChange="handleSuggestorChange('geozone')"
          />
        </div>
        <div class="fr-col-12 fr-col-md-3">
          <Suggestor
            :placeholder="$t('Territorial granularity')"
            :searchPlaceholder="$t('Search a granularity...')"
            listUrl="/spatial/granularities/"
            :values="facets.granularity"
            :onChange="handleSuggestorChange('granularity')"
          />
        </div>
      </div>
    </div>
    <div class="fr-my-9v text-align-center fr-hidden-md">
      <button
        class="fr-btn fr-btn--secondary fr-btn--secondary-grey-400"
        @click="extendedForm = !extendedForm"
        >{{ $t("Submit") }}</button>
    </div>
  </section>
  <section class="search-results fr-mt-1w fr-mt-md-3w" ref="results" v-bind="$attrs">
    <transition mode="out-in">
      <div v-if="loading">
        <Loader />
      </div>
      <ul v-else-if="results.length">
        <li
          v-for="result in results"
          :key="result.id"
        >
          <a
            :href="result.page"
            class="unstyled w-10 block"
          >
            <Dataset v-bind="result" />
          </a>
        </li>
        <Pagination
          v-if="totalResults > pageSize"
          :page="currentPage"
          :pageSize="pageSize"
          :totalResults="totalResults"
          :changePage="changePage"
          class="fr-mt-2w"
        />
      </ul>
      <div v-else>
        <Empty
          wide
          :queryString="queryString"
          :cta="$t('Reset filters')"
          :copy="$t('No dataset matching your query')"
          :copyAfter="
            $t('You can try to reset the filters to expand your search.')
          "
          :onClick="() => resetFilters()"
        />
      </div>
    </transition>
  </section>
</template>

<script>
import config from "../../config";
import SearchInput from "./search-input";
import Suggestor from "./suggestor";
import Rangepicker from "./rangepicker";
import Dataset from "../dataset/search-result";
import Loader from "../dataset/loader";
import Empty from "./empty";
import Pagination from "../pagination/pagination";
import {generateCancelToken} from "../../plugins/api";
import filterIcon from "svg/filter.svg";
import axios from "axios";
import queryString from "query-string";
import i18n from "../../plugins/i18n";

export default {
  components: {
    "search-input": SearchInput,
    Rangepicker,
    Suggestor,
    Dataset,
    Empty,
    Loader,
    Pagination,
  },
  props: {
    disableFirstSearch: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    // Update search params from URL on page load for deep linking
    const url = new URL(window.location);
    let searchParams = queryString.parse(url.search);
    if (searchParams.q) {
      this.queryString = searchParams.q;
      delete searchParams.q;
    }
    if (searchParams.page) {
      this.currentPage = parseInt(searchParams.page);
      delete searchParams.page;
    }
    // set all other search params as facets
    this.facets = searchParams;
    // Match DatasetListView.default_sort when search service has no sort param
    if (!this.facets.sort) {
      this.facets.sort = "-last_update";
    }
    if(this.disableFirstSearch) {
      this.loading = true;
    } else {
      this.search();
    }
  },
  mounted() {
    if(this.disableFirstSearch) {
      if (this.$refs.results.dataset.totalResults > 0) {
        this.results = JSON.parse(this.$refs.results.dataset.results);
        this.totalResults = JSON.parse(this.$refs.results.dataset.totalResults);
      }
      this.loading = false;
    }
  },
  watch: {
    paramUrl: {
      deep: true,
      handler(val) {
        // Update URL to match current search params value for deep linking
        let url = new URL(window.location);
        url.search = queryString.stringify(val, {skipNull: true});
        history.pushState(null, "", url);
      },
    },
  },
  data() {
    return {
      extendedForm: false, // On desktop, extended form is simply another row of filters. On mobile, form is hidden until extendedForm is triggered
      results: [],
      loading: false,
      currentRequest: null,
      pageSize: 20,
      currentPage: 1,
      totalResults: 0,
      queryString: "",
      facets: {},
      sortValues: [
        //{ label: i18n.global.t("Created date asc") , value: 'created'},
        { label: i18n.global.t("Created date desc") , value: '-created'},
        //{ label: i18n.global.t("Last modified asc") , value: 'last_modified'},
        { label: i18n.global.t("Last modified desc") , value: '-last_update'},
        //{ label: i18n.global.t("Title asc") , value: 'title'},
        //{ label: i18n.global.t("Title desc") , value: '-title'},
        //{ label: i18n.global.t("Followers asc") , value: 'followers'},
        { label: i18n.global.t("Followers desc") , value: '-followers'},
        //{ label: i18n.global.t("Reuses asc") , value: 'reuses'},
        { label: i18n.global.t("Reuses desc") , value: '-reuses'},
      ],
      rechercherBetaPath: "https://rechercher.etalab.studio/",
      filterIcon,
    };
  },
  computed: {
    // Url for doing the same search (queryString only) on the reuse page
    reuseUrl() {
      return `${config.values.reuseUrl}?q=${this.queryString}`;
    },
    // Is any filter active ?
    isFiltered() {
      return Object.keys(this.facets).some(
        (key) => this.facets[key]?.length > 0
      );
    },
    paramUrl() {
      let params = {};
      for (key in this.facets) {
        params[key] = this.facets[key];
      }
      if (this.currentPage > 1) params.page = this.currentPage;
      if (this.queryString) params.q = this.queryString;
      return params;
    },
  },
  methods: {
    handleSearchChange(input) {
      this.queryString = input;
      this.currentPage = 1;
      this.search();
    },
    changeSort(event) {
      if(event.target.value === "" || !event.target.value) {
        delete this.facets['sort'];
      } else {
        this.facets['sort']=event.target.value;
      }
      this.currentPage = 1;
      this.search();
    },
    // Called on every facet selector change, updates the `facets.xxx` object then searches with new values
    handleSuggestorChange(facet) {
      return (values) => {
        // Values can either be an array of varying length, or a String.
        if (Array.isArray(values)) {
          if (values.length > 1)
            this.facets[facet] = values.map((obj) => obj.value);
          else if (values.length === 1) this.facets[facet] = values[0].value;
          else this.facets[facet] = null;
        } else {
          this.facets[facet] = values;
        }

        this.currentPage = 1;
        this.search();
      };
    },
    changePage(page) {
      this.currentPage = page;
      this.search();
      this.scrollToTop();
    },
    search() {
      this.loading = true;
      if (this.currentRequest) this.currentRequest.cancel();

      this.currentRequest = generateCancelToken();

      this.$apiv2
        .get("/datasets/search/", {
          cancelToken: this.currentRequest.token,
          params: {
            q: this.queryString,
            ...this.facets,
            page_size: this.pageSize,
            page: this.currentPage,
          },
        })
        .then((res) => res.data)
        .then((result) => {
          this.results = result.data;
          this.totalResults = result.total;
          this.loading = false;
        })
        .catch((error) => {
          if (!axios.isCancel(error)) {
            this.$toast.error(this.$t("Error getting search results."));
            this.loading = false;
          }
        });
    },
    scrollToTop() {
      if (this.$refs.input)
        this.$refs.input.$el.scrollIntoView({ behavior: "smooth" });
    },
    resetFilters() {
      this.queryString = "";
      this.facets = {};
      this.currentPage = 1;
      this.search();
    },
  },
};
</script>
